import styled from 'styled-components';
import { IThemeProvider, ITheme } from '../../styles/theme';

interface ISliderCont {
  theme: ITheme;
  height?: string;
}

export const SliderCont = styled.div<ISliderCont>`
  display: flex;
  position: initial;
  flex-direction: column;
  justify-content: center;

  ${({ theme, height }: ISliderCont) => `
    height: ${height || 'fit-content'};
    margin: 0 ${theme.layout.spacing.centy} ${theme.layout.spacing.centy};
  `}

  .ant-carousel {
    display: flex;
    flex-direction: column;
    flex: 1;

    .slick-slider.slick-initialized {
      flex: 1;
      position: initial;

      .slick-dots.slick-dots-bottom {
        bottom: 28px;
      }

      .slick-dots.slick-dots-bottom li {
        button {
          cursor: pointer;
          transition: linear 0.2s;
          ${({ theme }: IThemeProvider) => `
              background: ${theme.colors.secondary[30]};
              border-radius: ${theme.layout.spacing.decy};
              width: ${theme.layout.spacing.centy};
              height: ${theme.layout.spacing.centy};
              margin: 0 ${theme.layout.spacing.nano};
              opacity: 1;
            `}
        }

        &.slick-active button {
          ${({ theme }: IThemeProvider) => `
            background: ${theme.colors.secondary[70]};
            width: ${theme.layout.spacing.decy};
          `}
        }
      }
    }
  }
`;

export const ArrowBtn = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  &:first-child {
    ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
  `}
  }
  span:hover {
    ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.secondary[10]};
  `}
  }
  span:active {
    ${({ theme }: IThemeProvider) => `
      background: ${theme.colors.secondary[30]};
    `}
  }
`;

export const LeftArrowBtn = styled(ArrowBtn)`
  > span {
    background: #f2f2f2;
  }

  ${({ theme }: IThemeProvider) => `
    left: ${theme.layout.spacing.centy};
  `}
`;

export const RightArrowBtn = styled(ArrowBtn)`
  > span {
    background: #f2f2f2;
  }

  ${({ theme }: IThemeProvider) => `
    right: ${theme.layout.spacing.centy};
  `}
`;
